import React, { Fragment } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, MinusIcon, PlusIcon, ShoppingCartIcon } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
export function CartPopup() {
  const {
    items,
    removeItem,
    updateQuantity,
    totalPrice,
    isOpen,
    closeCart
  } = useCart();
  return <AnimatePresence mode="wait" data-id="element-9">
      {isOpen && <Fragment key="cart-popup" data-id="element-10">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={closeCart} className="fixed inset-0 bg-black/50 z-40" data-id="element-11" />

          {/* Cart Popup */}
          <motion.div initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="fixed right-0 top-0 h-full w-full max-w-md bg-white shadow-2xl z-50 flex flex-col" data-id="element-12">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-13">
              <div className="flex items-center gap-3" data-id="element-14">
                <ShoppingCartIcon className="w-6 h-6 text-brand-red" data-id="element-15" />
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-16">Your Cart</h2>
              </div>
              <button onClick={closeCart} className="p-2 hover:bg-gray-100 rounded-full transition-colors" aria-label="Close cart" data-id="element-17">
                <XIcon className="w-6 h-6 text-gray-600" data-id="element-18" />
              </button>
            </div>

            {/* Cart Items */}
            <div className="flex-1 overflow-y-auto p-6" data-id="element-19">
              {items.length === 0 ? <div className="flex flex-col items-center justify-center h-full text-center" data-id="element-20">
                  <ShoppingCartIcon className="w-16 h-16 text-gray-300 mb-4" data-id="element-21" />
                  <p className="text-gray-600 text-lg" data-id="element-22">Your cart is empty</p>
                  <p className="text-gray-500 text-sm mt-2" data-id="element-23">
                    Add items to get started
                  </p>
                </div> : <div className="space-y-4" data-id="element-24">
                  <AnimatePresence mode="popLayout" data-id="element-25">
                    {items.map(item => <motion.div key={item.id} layout initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -20
              }} className="flex gap-4 p-4 bg-gray-50 rounded-lg border border-gray-200" data-id="element-26">
                        {/* Item Image */}
                        {item.image && <img src={item.image} alt={item.name} className="w-20 h-20 object-cover rounded-lg" data-id="element-27" />}

                        {/* Item Details */}
                        <div className="flex-1" data-id="element-28">
                          <h3 className="font-semibold text-gray-900 mb-1" data-id="element-29">
                            {item.name}
                          </h3>
                          <p className="text-brand-red font-bold text-lg mb-2" data-id="element-30">
                            ${item.price.toFixed(2)}
                          </p>

                          {/* Quantity Controls */}
                          <div className="flex items-center gap-3" data-id="element-31">
                            <button onClick={() => updateQuantity(item.id, item.quantity - 1)} className="p-1 hover:bg-gray-200 rounded transition-colors" aria-label="Decrease quantity" data-id="element-32">
                              <MinusIcon className="w-4 h-4 text-gray-600" data-id="element-33" />
                            </button>
                            <span className="text-gray-900 font-medium w-8 text-center" data-id="element-34">
                              {item.quantity}
                            </span>
                            <button onClick={() => updateQuantity(item.id, item.quantity + 1)} className="p-1 hover:bg-gray-200 rounded transition-colors" aria-label="Increase quantity" data-id="element-35">
                              <PlusIcon className="w-4 h-4 text-gray-600" data-id="element-36" />
                            </button>
                          </div>
                        </div>

                        {/* Remove Button */}
                        <button onClick={() => removeItem(item.id)} className="p-2 hover:bg-red-50 rounded transition-colors self-start" aria-label="Remove item" data-id="element-37">
                          <XIcon className="w-5 h-5 text-red-500" data-id="element-38" />
                        </button>
                      </motion.div>)}
                  </AnimatePresence>
                </div>}
            </div>

            {/* Footer */}
            {items.length > 0 && <div className="border-t border-gray-200 p-6 space-y-4" data-id="element-39">
                {/* Total */}
                <div className="flex items-center justify-between text-xl font-bold" data-id="element-40">
                  <span className="text-gray-900" data-id="element-41">Total:</span>
                  <span className="text-brand-red" data-id="element-42">
                    ${totalPrice.toFixed(2)}
                  </span>
                </div>

                {/* Checkout Button */}
                <button className="w-full bg-brand-red text-white py-4 rounded-lg font-semibold text-lg hover:bg-red-700 transition-colors shadow-lg" onClick={() => {
            window.location.href = 'https://crowncontrol.shop/order';
          }} data-id="element-43">
                  Proceed to Checkout
                </button>

                <p className="text-sm text-gray-600 text-center" data-id="element-44">
                  Free shipping · 180-Day Guarantee
                </p>
              </div>}
          </motion.div>
        </Fragment>}
    </AnimatePresence>;
}